import Axios from 'axios';
import Qs from 'qs';

export default {

  // 帖子分页列表
  listPage(
    community_id,
    keyword,
    posts_keyword,
    nickname,
    category_id,
    page,
    per_page
  ) {
    return Axios.get('/llhd/api/admin/comments', {
      params: {
        community_id,
        keyword,
        posts_keyword,
        nickname,
        category_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 评论回复
  reply(
    community_id,
    id,
    content,
    dialog_comment_id
  ) {
    return Axios.post(`/llhd/api/admin/posts/comment/${id}/reply`, {
      community_id,
      content,
      dialog_comment_id
    });
  },

  // 评论启用
  enable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/posts/comment/${id}/hide`, {
      is_hide: 0
    })
  },

  // 评论禁用
  disable(
    id
  ) {
    return Axios.post(`/llhd/api/admin/posts/comment/${id}/hide`, {
      is_hide: 1
    })
  },

  // 评论回复分页列表
  replyListPage(
    id,
    page,
    per_page
  ) {
    return Axios.get(`/llhd/api/admin/posts/comment/${id}/dialog`, {
      params: {
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  }

}